import React from 'react'
import { Box } from '@mui/material'
import { useSidebarControls } from 'src/designSystem/Container/sidebarControls'
import PriorityFilterChip from 'src/participantsHome/PriorityFilterChip'
import { TOUR_ANCHORS } from '../tour/anchors'
import { CaseloadFilter } from './caseloadIndicators'

type Props = {
  filters: CaseloadFilter[]
  counts: Record<string, number>
  selected: string | null
  onChange: (selected: string | null) => void
}

const CaseloadIndicatorFilters = ({ filters, counts, selected, onChange }: Props) => {
  const { isExpanded } = useSidebarControls()

  if (filters.length === 0) {
    return null
  }

  return (
    <Box
      data-tour={TOUR_ANCHORS.caseloadIndicatorFilters}
      sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1, px: 2, pt: 2 }}
    >
      {filters.map((filter) => (
        <PriorityFilterChip
          key={filter.key}
          label={filter.label}
          icon={filter.icon}
          count={counts[filter.key] ?? 0}
          selected={filter.key === selected}
          expanded={isExpanded}
          onClick={() => onChange(filter.key === selected ? null : filter.key)}
        />
      ))}
    </Box>
  )
}

export default CaseloadIndicatorFilters
